import axios, { AxiosInstance } from 'axios';
// DEBUG import { axiosInstance } from './axiosInstance';
import AxiosRetry from 'axios-retry';
import { registerAxiosTelemetry } from '../services/applicationInsights';

const engagementApiUrl = process.env.NEXT_PUBLIC_ENGAGEMENT_API_URL;

const setHeaders = (config) => {
	if (config.method === 'post') {
		// try force Content-Type header
		config.headers['Content-Type'] = 'application/json; charset=UTF-8';
	}
	// DEBUG config.headers['Accept-Language'] = 'da';
	config.headers.Accept = '*/*';
};

// *************Axios retry twice*************
const instanceRetry = axios.create({
	baseURL: engagementApiUrl,
	// DEBUG  httpAgent: axiosInstance.defaults.httpAgent,
	// DEBUG  httpsAgent: axiosInstance.defaults.httpsAgent,
	timeout: 10000,
});

const axiosRetry = AxiosRetry;

const retryConfig = {
	retries: 2,
	retryDelay: (retryCount: number) => {
		return retryCount * 100; // time interval between retries
	},
	retryCondition: (error) => {
		if (!error?.response?.status) {
			return true;
		}
		return error?.response?.status > 240;
	},
	shouldResetTimeout: true,
};

axiosRetry(instanceRetry, retryConfig);

instanceRetry.interceptors.request.use((config) => {
	setHeaders(config);
	return config;
});

// Register telemetry BEFORE the error-wrapping interceptor so it receives the
// original AxiosError (status/url/method/code). Response interceptors run in
// registration order, so this one sees errors first.
registerAxiosTelemetry(instanceRetry);

instanceRetry.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// Network failures (no response at all) must not crash the interceptor —
		// callers rely on the thrown error to classify CSP / CORS / timeout, etc.
		if (error?.response?.status === 401) location.href = '/logud';
		throw { error };
	},
);

// No-op when the App Insights connection string is empty.

export const getApiRetryInstance = (timeout = 10000): AxiosInstance => {
	instanceRetry.defaults.timeout = timeout;
	return instanceRetry;
};
